import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import { DELETE_SALON_TAG_FAILURE, DELETE_SALON_TAG_REQUEST, DELETE_SALON_TAG_SUCCESS } from './deleteSalonTag.types';

const ATAG = 'deleteSalonTag';
const L = logger(ATAG);

const deleteSalonTag = L.wrap('()', (options) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint(),
    ...jsonEndpoint(H.del, `salon/v2/${asObject(options).salonId}/client_tags/${asObject(options).tagId}/`),
    types: [DELETE_SALON_TAG_REQUEST, DELETE_SALON_TAG_SUCCESS, DELETE_SALON_TAG_FAILURE],
    params: { tagId: asObject(options).tagId },
    meta: { analytics: EventTypes.track },
  },
}));

// noinspection JSUnusedGlobalSymbols
export default deleteSalonTag;
